import React from 'react';
import {ChromePicker} from 'react-color'
function FormBirthday({name, label, sublabel, register, control, ...otherProps}) {

    var {color} = otherProps;
    var {error} = otherProps;
    const invalidStyle = {width: "100%", marginTop: "0.25rem", fontSize: "80%", color: "#ff4136"}
    const [hexPick, setHexPick] = React.useState(color)

    const {fullSize} = otherProps;
    const leftCol = fullSize ? "col-md-3" : "col-md-2"
    // const rightCol = fullSize ? "col-md-3" : "col-md-2"
    const rightCol = fullSize ? "col-md-9" : "col-md-6"

    const updateSelection = (hex) => {
        if (otherProps.onChange ) {
            otherProps.onChange(hex)
        }
    }

    const handleChange = (color, event) => {
        setHexPick(color.hex)
        updateSelection(color.hex)
    }

    const [showPicker, setShowPicker] = React.useState(false)

    return (
    <div className="form-group row">
        {label && (<label className={`${leftCol} col-form-label`}>
            <h6>{label}</h6>
            {sublabel && (<small>{sublabel}</small>)}
        </label>)}

        <div onClick={() => setShowPicker(!showPicker)} className={`col-md-2 mb-2 d-flex flex-row align-items-center`}>
            <input className="form-control"  type="text" disabled={true} value={hexPick}></input>
            <div style={{borderRadius: "4px", backgroundColor: hexPick, width: "28px", height: "28px", marginLeft: "-36px"}}></div>
        </div>

        {showPicker && (
            <ChromePicker
            color={hexPick}
            onChange={handleChange}
            style={{popover: {position: 'absolute', zIndex: '2'}}}
            />
        )}

        {error && (
            <div style={invalidStyle}>
                {error.message}
            </div>
        )}

    </div>
    );
}

export default FormBirthday
